(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/javascripts/routes.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/javascripts/routes.js');

'use strict';

const routes = {
  home: {
    pattern: '/',
    routeComponents: ['page-start'],
    title: 'Det här är Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Vinn på din favoritplats i nya Lyckoplatsen. Du kan vinna på din plats flera gånger i veckan. Du kan också vinna om du är nära den vinnande platsen.'
  },
  play: {
    pattern: '/spela',
    routeComponents: ['page-play'],
    title: 'Välj din plats och spela Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Spela på din hemadress, nuvarande plats eller valfri plats i Sverige. Är din lyckoplats i sommarstugan, där du gifte dig eller kanske din favoritarena?'
  },
  prolong: {
    pattern: '/forlang-mina-spel/:wagerId([0-9]+)',
    routeComponents: ['page-play'],
    roles: ['Player']
  },
  result: {
    pattern: '/resultat',
    routeComponents: ['page-result'],
    title: 'Resultat och vinstkarta för Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Se vart vinsten gick vid senaste dragningen av Lyckoplatsen på resultatsidan och om du vunnit på någon av dina lyckoplatser.'
  },
  resultDate: {
    pattern: '/resultat/:dateString',
    routeComponents: ['page-result'],
    title: 'Resultat och vinstkarta för Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Se vart vinsten gick vid senaste dragningen av Lyckoplatsen på resultatsidan och om du vunnit på någon av dina lyckoplatser.'
  },
  charityPayout: {
    pattern: '/valgorenhet',
    routeComponents: ['page-charity-payout'],
    title: 'Spela Lyckoplatsen och stötta en god sak | Svenska Spel Tur',
    metaDescription: 'Välj en välgörenhet att bidra till när du spelar Lyckoplatsen. Vill kallar det att spela för en god sak. Att välja en god sak kostar inget extra.'
  },
  mybets: {
    pattern: '/mina-spel',
    roles: ['Player'],
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    action: (_, res) => res.redirect('mina-spel/pagaende')
  },
  editSubscription: {
    pattern: '/min-prenumeration/:subscriptionId([0-9a-zA-Z]+)',
    routeComponents: ['page-play'],
    roles: ['Player']
  },
  mybetsOngoing: {
    pattern: '/mina-spel/pagaende',
    routeComponents: ['page-mybets-ongoing'],
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    roles: ['Player'],
    hideNav: true
  },
  mybetsOngoingDetail: {
    pattern: '/mina-spel/:wagerId([0-9]+)',
    routeComponents: ['page-mybets-ongoing'],
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    roles: ['Player'],
    hideNav: true
  },
  mybetsFinishedDetail: {
    pattern: '/mina-spel/:product(48|49)/:wagerId([0-9]+)/:drawNumber([0-9]+)',
    routeComponents: ['page-mybets-finished'],
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    roles: ['Player'],
    hideNav: true
  },
  mybetsSubscriptionDetail: {
    pattern: '/mina-spel/prenumeration/:subscriptionId([0-9a-zA-Z]+)',
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    routeComponents: ['page-mybets-subscription'],
    roles: ['Player'],
    hideNav: true
  },
  related: {
    pattern: '/relaterat/:wagerId([0-9]+)?/:charityId(-1|[0-9]+)?',
    routeComponents: ['page-related'],
    title: 'Relaterat till Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Om du gillar att spela Lyckoplatsen kanske du även gillar dessa spel. Skrapa en lott i väntan på nästa dragning eller fyll veckan med fler dragningar.'
  },
  mailCorrection: {
    pattern: '/mina-spel/ratta/id/:accessToken/:drawNumber([0-9]+)/:product([0-9]+)',
    routeComponents: ['page-mybets-finished'],
    title: 'Mina spel på Lyckoplatsen | Svenska Spel Tur',
    metaDescription: 'Här hittar du alla dina spel på Lyckoplatsen. Du kan rätta och förlänga dina spel och se om din plats är den som vunnit i senaste dragningen.',
    hideNav: true
  }
};
if (svs.isServer) {
  module.exports = routes;
} else {
  Object.assign(svs.lyckoplatsen, {
    routes
  });
}

 })(window);